import { gql } from "@grandvisionhq/graphql";
const REQUEST_SOCIAL_LOGIN_MERGE = gql`
  mutation requestSocialLoginMerge {
    # This is a void mutation
    requestSocialLoginMerge {
      failures {
        __typename
      }
    }
  }
`;
export {
  REQUEST_SOCIAL_LOGIN_MERGE
};
//# sourceMappingURL=request-social-login-merge.js.map
